import AirtableTable from "../AirtableTable";
import { ResourceSubmission } from "../models";
import { airtableFields, airtableTables } from "../schema";

export const resourceSubmissionFieldIds = airtableFields.resourceSubmissions;

export class ResourceSubmissionsTable extends AirtableTable<ResourceSubmission> {
  constructor(instance: any) {
    super(instance, airtableTables.resourceSubmissions);

    this.fields = [
      resourceSubmissionFieldIds.firstName,
      resourceSubmissionFieldIds.lastName,
      resourceSubmissionFieldIds.email,
      resourceSubmissionFieldIds.resourceTitle,
      resourceSubmissionFieldIds.resourceDescription,
      resourceSubmissionFieldIds.attachments,
      resourceSubmissionFieldIds.resourceLink,
      resourceSubmissionFieldIds.userSubmittedOutcomes,
      resourceSubmissionFieldIds.consentToShareResource,
      resourceSubmissionFieldIds.consentToIncludeName,
      resourceSubmissionFieldIds.status,
      resourceSubmissionFieldIds.attachmentSummary,
      resourceSubmissionFieldIds.submitAnonymously,
      resourceSubmissionFieldIds.resourceType,
      resourceSubmissionFieldIds.created,
      resourceSubmissionFieldIds.submissionTime
    ];
  }
}
